import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./LoginPage.css";
import APP_VERSION from "../version";
import { Loader } from "@googlemaps/js-api-loader";

export default function AddLocation() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    address: "",
    latitude: null,
    longitude: null,
    phone_contact: "",
    email_contact: "",
    campsite_url: "",
    site_features: [],
    share_flag: true,
    drivetrain: "",
    pet_friendly: false,
  });

  const [featureInput, setFeatureInput] = useState("");
  const [filteredFeatures, setFilteredFeatures] = useState([]);
  const [selectedFeatureNames, setSelectedFeatureNames] = useState([]);
  const debounceTimeoutRef = useRef(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: "AIzaSyDouCFVON6WJwswrrNSIqM_VR1xQr0UCRs",
      version: "weekly",
      libraries: ["places"],
    });

    loader.load().then(() => {
      const input = document.getElementById("autocomplete");
      if (!input) return;

      const autocomplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: ["au"] },
        fields: ["formatted_address", "geometry"],
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) return;

        setForm((prev) => ({
          ...prev,
          address: place.formatted_address,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        }));
      });
    });
  }, []);

  useEffect(() => {
    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

    if (featureInput.length > 1) {
      debounceTimeoutRef.current = setTimeout(async () => {
        try {
          const response = await fetch(`/api/locations/site_features/lookup?query=${featureInput}`);
          if (!response.ok) {
            const errorData = await response.json();
            console.error("Failed to fetch feature lookup:", errorData.error || "Unknown error");
            setFilteredFeatures([]);
            return;
          }
          const data = await response.json();
          setFilteredFeatures(data);
        } catch (error) {
          console.error("Error fetching feature lookup:", error);
          setFilteredFeatures([]);
        }
      }, 300);
    } else {
      setFilteredFeatures([]);
    }
  }, [featureInput]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const addFeature = (feature) => {
    if (!form.site_features.includes(feature.id)) {
      setForm((prev) => ({
        ...prev,
        site_features: [...prev.site_features, feature.id],
      }));
      setSelectedFeatureNames((prev) => [...prev, { id: feature.id, name: feature.name }]);
    }
    setFeatureInput("");
    setFilteredFeatures([]);
  };

  const removeFeature = (featureId) => {
    setForm((prev) => ({
      ...prev,
      site_features: prev.site_features.filter((fId) => fId !== featureId),
    }));
    setSelectedFeatureNames((prev) => prev.filter((f) => f.id !== featureId));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.address || form.latitude === null || form.longitude === null) {
      alert("Please select a valid address from the suggestions.");
      return;
    }

    const payload = { ...form };

    try {
      const res = await fetch("/api/locations", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        alert("Campsite added successfully!");
        navigate("/createtrip");
      } else {
        const errorData = await res.json();
        console.error("Failed to save location:", errorData.error || "Unknown error");
        alert(`Error: ${errorData.error || "Failed to save location."}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An unexpected error occurred while saving the location.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div style={{ textAlign: "center" }}>
          <img
            src="/add-camp-image.png"
            alt="Add Campsite"
            style={{ width: "200px", margin: "0 auto 20px auto", display: "block" }}
          />
        </div>

        <h2>Add a Campsite</h2>

        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Campsite Name"
            value={form.name}
            onChange={handleChange}
            required
            style={{ marginBottom: "10px" }}
          />

          <input
            id="autocomplete"
            type="text"
            placeholder="Enter Campsite Address"
            style={{ width: "100%", marginBottom: "10px", padding: "10px" }}
          />

          <input
            type="text"
            name="phone_contact"
            placeholder="Phone Number"
            value={form.phone_contact}
            onChange={handleChange}
            style={{ marginBottom: "10px" }}
          />

          <input
            type="email"
            name="email_contact"
            placeholder="Email Address"
            value={form.email_contact}
            onChange={handleChange}
            style={{ marginBottom: "10px" }}
          />

          <input
            type="url"
            name="campsite_url"
            placeholder="Campsite Website URL (optional)"
            value={form.campsite_url}
            onChange={handleChange}
            style={{ marginBottom: "10px" }}
          />

            <select
            name="drivetrain"
            value={form.drivetrain}
            onChange={handleChange}
            required
            style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                marginBottom: "10px",
                backgroundColor: "#fff",
                appearance: "none",
                backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="292.4" height="292.4"%3E%3Cpath fill="%23000" d="M287,197.377L146.202,56.577,5.4,197.377H287z"/%3E%3C/svg%3E')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "12px",
            }}
            >
            <option value="" disabled hidden>
                Select access
            </option>
            <option value="2 Wheel Drive">2 Wheel Drive</option>
            <option value="All Wheel Drive">All Wheel Drive</option>
            <option value="4 Wheel Drive">4 Wheel Drive</option>
            </select>


          <div style={{ marginBottom: "10px", position: "relative" }}>
            <input
              type="text"
              placeholder="Search for features..."
              value={featureInput}
              onChange={(e) => setFeatureInput(e.target.value)}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                padding: "10px",
                borderRadius: "6px",
              }}
            />
            {filteredFeatures.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderTop: "none",
                  borderRadius: "0 0 6px 6px",
                  zIndex: 1000,
                  maxHeight: "200px",
                  overflowY: "auto",
                }}
              >
                {filteredFeatures.map((feature) => (
                  <div
                    key={feature.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: "1px solid #eee",
                      color: "#000",
                      backgroundColor: "#fff",
                    }}
                  >
                    <span style={{ flexGrow: 1, textAlign: "left" }}>{feature.name}</span>
                    <button
                      type="button"
                      onClick={() => addFeature(feature)}
                      style={{
                        backgroundColor: "#2c7373",
                        color: "#fff",
                        border: "none",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "0.8em",
                        fontWeight: "bold",
                      }}
                    >
                      Select
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              padding: "10px",
              marginBottom: "10px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              minHeight: "50px",
              display: "flex",
              flexWrap: "wrap",
              gap: "6px 10px",
              alignItems: "flex-start",
            }}
          >
            {selectedFeatureNames.length === 0 ? (
              <p style={{ color: "#777", fontStyle: "italic" }}>No features selected yet</p>
            ) : (
              selectedFeatureNames.map((feature) => (
                <div
                  key={feature.id}
                  style={{
                    backgroundColor: "#d0eaff",
                    padding: "6px 12px",
                    borderRadius: "16px",
                    fontSize: "0.9em",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#000",
                    lineHeight: "1",
                    whiteSpace: "nowrap",
                    alignSelf: "flex-start",
                    height: "32px",
                  }}
                >
                  <span style={{ marginRight: "6px" }}>{feature.name}</span>
                  <button
                    type="button"
                    onClick={() => removeFeature(feature.id)}
                    aria-label={`Remove ${feature.name}`}
                    style={{
                      background: "#ccc",
                      border: "none",
                      borderRadius: "50%",
                      color: "#333",
                      width: "18px",
                      height: "18px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                      transition: "background 0.2s, color 0.2s",
                    }}
                  >
                    ×
                  </button>
                </div>
              ))
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
            <label style={{ display: "inline-flex", alignItems: "center", gap: "10px", whiteSpace: "nowrap" }}>
                <span>Pet friendly?</span>
                <input type="checkbox" name="pet_friendly" checked={form.pet_friendly} onChange={handleChange} />
            </label>
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
            <label style={{ display: "inline-flex", alignItems: "center", gap: "10px", whiteSpace: "nowrap" }}>
                <span>Keep this location private?</span>
                <input
                type="checkbox"
                name="share_flag"
                checked={!form.share_flag}
                onChange={(e) => setForm((prev) => ({ ...prev, share_flag: !e.target.checked }))}
                />
            </label>
            </div>

          <button type="submit" className="green-button" style={{ marginTop: "10px" }}>
            Save Location
          </button>
        </form>

        <button className="home-button" onClick={() => navigate("/")} style={{ marginTop: "30px", width: "100%" }}>
          Home
        </button>

        <div
          className="version-text"
          style={{
            marginTop: "20px",
            fontSize: "12px",
            color: "#ccc",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            Version: <strong>{APP_VERSION}</strong>
          </span>
          <span>
            <Link to="/logout" className="contact-link" style={{ marginRight: "16px" }}>
              Logout
            </Link>
            <Link to="/contact" className="contact-link">
              Contact us
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
}
